<template>
    <div class='container clause'>
        <h3 class='text text-center'>{{content.title}}</h3>
        <h4 class='text text-center text-subtitle' v-html='content.subtitle'/>
        <p class='text text-center text-small text-subtitle' v-if='content.register_number'>{{content.register_number}}</p>
        <div v-for='(item, index) in content.protocols' :key='`protocol-${index}`'>
            <h4 class='text text-center text-separate' v-if='item.intro'>{{item.intro}}</h4>
            <div v-for='(clause, index) in item.list' :key='`clause-${index}`'>
                <p>
                    <strong class='clause-order'>{{clause.order}}</strong>
                    {{clause.context}}
                </p>
                <div v-for='(detail, index) in clause.details' :key='`detail-${index}`'>
                    <p v-if='detail.text'>{{detail.text}}</p>
                    <ul v-if='detail.regulations' class='clause-list'>
                        <li v-for='(regulation, index) in detail.regulations' :key='`regulation-${index}`'>
                            {{regulation}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if='content.appendix' class='clause-appendix'>
            <h4 class='text text-center text-separate'>附录</h4>
            <div>{{content.appendix.intro}}</div>
            <table class='clause-table'>
                <tbody>
                    <tr v-for='(column, index) in content.appendix.table' :key='`column-${index}`'>
                        <td v-for='(item, index) in column' :key='`item-${index}`'>
                            {{item}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>{{content.appendix.annotation}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['content']
    }
</script>
